module.exports = "/assets/7f91a092c737a1f360eb14391d541630.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4M.png
// module id = 1039
// module chunks = 0